var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "menu",
    xmlns: "http://www.w3.org/2000/svg",
    width: 29.526,
    height: 21.324,
    viewBox: "0 0 29.526 21.324",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_17448",
    "data-name": "Path 17448",
    d: "M28.3,125.128H1.23a1.23,1.23,0,0,1,0-2.46H28.3a1.23,1.23,0,0,1,0,2.46Zm0,0",
    transform: "translate(0 -113.236)",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_17449",
    "data-name": "Path 17449",
    d: "M28.3,2.46H1.23A1.23,1.23,0,0,1,1.23,0H28.3a1.23,1.23,0,0,1,0,2.46Zm0,0",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_17450",
    "data-name": "Path 17450",
    d: "M28.3,247.792H1.23a1.23,1.23,0,0,1,0-2.46H28.3a1.23,1.23,0,0,1,0,2.46Zm0,0",
    transform: "translate(0 -226.468)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenu);
export default __webpack_public_path__ + "static/media/menu.488ca231fc6ce738f8fa1efbcae539a2.svg";
export { ForwardRef as ReactComponent };